import { createFileRoute } from '@tanstack/react-router';

import { RatPage } from '@/features/compliance/components/rat-page';
import { ComplianceSectionTabs } from '@/features/compliance/components/compliance-section-tabs';
import { useSelectedComplianceTenant } from '@/features/compliance/compliance-tenant-context';

export const Route = createFileRoute('/_app/compliance/rat')({
  component: ComplianceRatRoute,
});

function ComplianceRatRoute() {
  const { selectedTenant } = useSelectedComplianceTenant();
  return (
    <div className="flex flex-col gap-6">
      <ComplianceSectionTabs />
      <RatPage tenantId={selectedTenant?.tenantId ?? null} />
    </div>
  );
}
